<template>
  <div class="month-offers mt-5 p-5" data-aos="fade">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center">Les propositions du mois</h1>
          <div class="row content pt-5">
            <div v-for="(item, index) in month_offers" :key="index" class="col-12 mb-3">
              {{ item.month_offer_price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      month_offers: null
    }
  },
  methods: {
    /**
     * Get month offers data
     * @request HTTP | GET
     */
    fetchMonthOffers () {
      let url = api.month_offers
      this.axios.get(url)
        .then(response => {
          this.month_offers = response.data.acf.month_offers
          this.load = false
          window.prerenderReady = true
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchMonthOffers()
  }
}
</script>

<style lang="scss" scoped>
  @import 'MonthOffers';
</style>



// WEBPACK FOOTER //
// src/components/MonthOffers/MonthOffers.vue